export default "__VITE_ASSET__CwNtBpF9__"